import React, { useState } from "react";
import ExportAnalyticsReportModal from "../../../modals/ExportAnalyticsReportModal";

const PageHeader = () => {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  return (
    <>
      <div className="bg-white border-b shadow-sm p-6  flex justify-between gap-5 items-start lg:items-center flex-col lg:flex-row">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            {" "}
            Reporting & Analytics
          </h1>
          <p className="text-sm text-gray-600 mt-1">
            Track student performance, identify trends, and make data-driven
            decisions.
          </p>
        </div>
        <div className="space-x-2 flex gap-2">
          <button
            className="btn btn-small btn-secondary"
            onClick={() => setIsExportModalOpen(true)}
          >
            Export Report
          </button>
        </div>
      </div>

      <ExportAnalyticsReportModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
      />
    </>
  );
};

export default PageHeader;
